import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { ToastContainer } from "react-toastify";
import { ThemeProvider } from 'styled-components';
import { theme } from "./theme";
import 'react-toastify/dist/ReactToastify.css';
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <>
    <ThemeProvider theme={theme}>

      <ToastContainer />
      <App />
    </ThemeProvider>
  </>
);
